module.exports = __webpack_public_path__ + "img/bw_black_ba_list.11c0802a.jpg";